export default "__VITE_ASSET__CN8wtPZn__"